import type { SavedOnlineRating } from '../domain/online-rating';
import { t } from '../i18n';
import { GoogleSearchSuggestions } from './GoogleSearchSuggestions';
import { OnlineRatingValue } from './OnlineRatingValue';

/** How the last web completion went: something filled, nothing found, or a failure to say. */
export type CompletionOutcome =
  { kind: 'done' } | { kind: 'none' } | { kind: 'failed'; message: string };

/**
 * "Recherche en ligne" (owner request, 2026-10-03; renamed 2026-10-06; also run after a scan): one web
 * search fills the purchase form's empty fields and finds the wine's online rating. Shows only a
 * short outcome, the rating found (marked as online) and Google's search suggestions, which its
 * terms require with a search's result.
 */
export function WebCompletion({
  busy,
  disabled,
  onComplete,
  outcome,
  rating,
  searchSuggestions,
}: {
  busy: boolean;
  disabled: boolean;
  onComplete: () => void;
  outcome: CompletionOutcome | undefined;
  rating: SavedOnlineRating | undefined;
  searchSuggestions: string | undefined;
}) {
  return (
    <div className="online-rating">
      <button type="button" className="cta-action" disabled={busy || disabled} onClick={onComplete}>
        {busy ? t('complete.searching') : t('complete.action')}
      </button>
      {outcome?.kind === 'failed' && (
        <p role="alert" className="suggestions__message">
          {outcome.message}
        </p>
      )}
      {outcome?.kind === 'none' && (
        <p role="status" className="suggestions__message">
          {t('complete.none')}
        </p>
      )}
      {outcome?.kind === 'done' && (
        <p role="status" className="suggestions__message">
          {t('complete.done')}
        </p>
      )}
      {rating && (
        <p className="online-rating__found">
          <OnlineRatingValue saved={rating} />
        </p>
      )}
      {searchSuggestions && <GoogleSearchSuggestions html={searchSuggestions} />}
    </div>
  );
}
